import React from 'react'
import styles from './NotFound.module.css'
import { TbError404Off } from "react-icons/tb";

const NotFound = () => {
  return (
    <div className={styles.wrapper}>
        <p>Страница не найдена</p>
        <i><TbError404Off/></i>
        </div>
  )
}

export default NotFound